import { userService } from "../user.service";
import { authenticationReducerActions, marketplaceSetupReducerActions } from "../../../_services/store";
import {
    fireGTMTagAfterSuccessfulUserRegistration,
    fireMetaTagAfterSuccessfulUserRegistration,
} from "../../../organization/myOrganization/services/store/myOrganization.actions";

export const submitNewStripeMarketplaceInstallation = (nounce, isLiveMode, acceptDpa, acceptTos, isSandbox) => {
    const requestBody = {
        nounce,
        liveMode: isLiveMode,
        acceptDpa,
        acceptTos,
        sandbox: isSandbox,
    };

    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(marketplaceSetupReducerActions.submitStripeMarketplaceInstallationRequest());
            try {
                const result = await userService.installStripe(requestBody);
                fireGTMTagAfterSuccessfulUserRegistration();
                fireMetaTagAfterSuccessfulUserRegistration();
                dispatch(marketplaceSetupReducerActions.submitStripeMarketplaceInstallationSuccess(result));
            } catch (error) {
                dispatch(marketplaceSetupReducerActions.submitStripeMarketplaceInstallationFailure(error));
                reject(error);
            }
        });
    };
};

export const submitInitialLoginForExistingUser = (existingUserData) => {
    return async (dispatch) => {
        dispatch(marketplaceSetupReducerActions.submitInitialLoginForExistingUserRequest());
        try {
            const { email, password } = existingUserData;
            dispatch(authenticationReducerActions.loginRequest({ mail: email }));
            const user = await userService.login(email, password, null);
            dispatch(marketplaceSetupReducerActions.submitInitialLoginForExistingUserSuccess(user));
            dispatch(authenticationReducerActions.loginSuccess(user));
            return user;
        } catch (e) {
            dispatch(authenticationReducerActions.loginFailure(e));
            dispatch(marketplaceSetupReducerActions.submitInitialLoginForExistingUserFailure(e));
            throw e;
        }
    };
};

export const createNewStripeOrgForExistingUser = (registrationData, createNewOrg, isLiveMode, isSandbox) => {
    const requestBody = {
        nounce: registrationData.nounce,
        createNewOrg,
        email: registrationData.email,
        liveMode: isLiveMode,
        sandbox: isSandbox,
    };

    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(marketplaceSetupReducerActions.createNewStripeOrgForExistingUserRequest());
            try {
                const newOrg = await userService.createStripeOrgForExistingUser(requestBody);
                const user = await userService.login(
                    registrationData.email,
                    registrationData.password,
                    newOrg.externalUUID
                );
                await userService.selectOrganization(newOrg.externalUUID);
                await userService.mergeUserIntoStorage(user);
                dispatch(marketplaceSetupReducerActions.createNewStripeOrgForExistingUserSuccess());
                resolve(newOrg);
            } catch (error) {
                dispatch(marketplaceSetupReducerActions.createNewStripeOrgForExistingUserFailure(error));
                reject(error);
            }
        });
    };
};

export const connectNewStripeAccountToExistingOrg = (registrationData, createNewOrg, isLiveMode, isSandbox) => {
    const requestBody = {
        nounce: registrationData.nounce,
        createNewOrg,
        email: registrationData.email,
        selectedOrganizationExternalUUID: registrationData.selectedOrganizationExternalUUID,
        liveMode: isLiveMode,
        sandbox: isSandbox,
    };

    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(marketplaceSetupReducerActions.connectNewStripeAccountToExistingOrgRequest());
            try {
                let user = await userService.selectOrganization(registrationData.selectedOrganizationExternalUUID);
                user = await userService.mergeUserIntoStorage(user);
                dispatch(authenticationReducerActions.loginSuccess(user));
                const updatedOrg = await userService.createNewStripeShopForExistingOrgAndUser(requestBody);
                dispatch(marketplaceSetupReducerActions.connectNewStripeAccountToExistingOrgSuccess());
                resolve(updatedOrg);
            } catch (error) {
                dispatch(marketplaceSetupReducerActions.connectNewStripeAccountToExistingOrgFailure(error));
                reject(error);
            }
        });
    };
};

export const requestStripeSetupEmailResend = (nounce) => {
    return (dispatch) => {
        return new Promise(async (resolve, reject) => {
            dispatch(marketplaceSetupReducerActions.resendStripeEmailRequest());
            try {
                await userService.resendStripeEmailConfirmation(nounce);
                dispatch(marketplaceSetupReducerActions.resendStripeEmailSuccess());
            } catch (error) {
                dispatch(marketplaceSetupReducerActions.resendStripeEmailFailure(error));
                reject(error);
            }
        });
    };
};
